import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Box,
  Typography
} from '@mui/material';
import MroQmCompletionAcknowledgmentForm from './MroQmCompletionAcknowledgmentForm';

const MroQmCompletionAcknowledgment = ({ open, onClose, workOrder, onSuccess }) => {
  const handleClose = () => {
    onClose();
  };

  return (
    <Dialog open={open} onClose={handleClose} maxWidth="sm" fullWidth>
      <DialogTitle>MRO QM Completion Acknowledgment</DialogTitle>
      <DialogContent>
        <Box sx={{ mb: 2 }}>
          <Typography variant="body2" color="text.secondary" gutterBottom>
            Work Order: <strong>{workOrder?.title}</strong>
          </Typography>
          <Typography variant="body2" color="text.secondary">
            Aircraft: <strong>{workOrder?.aircraftId?.registration || 'Unknown'}</strong>
          </Typography>
        </Box>
        <MroQmCompletionAcknowledgmentForm
          workOrder={workOrder}
          onSuccess={() => {
            onSuccess?.();
            handleClose();
          }}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose}>Close</Button>
      </DialogActions>
    </Dialog>
  );
};

export default MroQmCompletionAcknowledgment;
